import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'no_cards.title',
        defaultMessage: 'No cards yet',
    },
    text: {
        id: 'no_cards.text',
        defaultMessage: 'Let’s get you started!',
    },
    button: {
        id: 'no_cards.button',
        defaultMessage: 'Get my card',
    },
})
